<template>
  <v-row>
    <v-col cols="12 py-0 pt-2 px-8">
      <h3>Thông tin SKU</h3>
    </v-col>
    <v-col cols="12" class="py-0 pt-4">
      <v-row>
        <v-col cols="6" class="py-0 px-8">
          <div class="d-flex">
            <v-btn
              class="btn-info"
              small
              @click="createSku"
            >
              + Thêm SKU
            </v-btn>
          </div>
        </v-col>
        <v-col cols="6" class="py-0 px-8 justify-end d-flex">
          <v-row>
            <v-col offset="6" cols="6" class="py-0">
              <v-text-field
                class="text-search"
                outlined
                dense
                placeholder="Nhập tên SKU"
                @keyup="searchSkuOffline"
                v-model="txtSkuName"
              >
                <v-icon
                  class="icon-search"
                  slot="prepend"
                  color="#adadad"
                >
                  mdi-magnify
                </v-icon>
              </v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col class="py-0 px-8 pb-3" cols="12">
      <v-simple-table class="table-layout table-custom table-sku">
        <thead>
          <tr>
            <th class="text-left">Mã SKU</th>
            <th class="text-left">Tên SKU*</th>
            <th class="col-name-card">Tên trên thẻ học*</th>
            <th class="text-left">Giá</th>
            <th class="text-left">Môn</th>
            <th class="text-left">Trạng thái*</th>
            <th class="text-center">Thao tác</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!skuItems.length">
            <td colspan="6">Không có dữ liệu</td>
          </tr>
          <template v-if="skuItems.length">
            <tr v-for="(item, index) in skuItems" :key="index">
              <td class="text-left">{{ item.code || '__' }}</td>
              <td class="text-left">{{ item.name }}</td>
              <td class="text-left">{{ item.cardDisplayName }}</td>
              <td class="text-left">{{ formatCurrency(item.comboPrice) }}</td>
              <td class="text-left">{{ getSubjectTitle(item.comboItems) }}</td>
              <td class="text-left">{{ skuStatusObj[item.status] }}</td>
              <td class="text-center">
                <ul class="list-action d-flex justify-center">
                  <li>
                    <div class="data-list text-left cursor-pointer">
                      <v-icon class="icon-list">mdi-format-list-bulleted</v-icon>
                      <div class="list-combo">
                        <div v-for="(itemCb, indexCb) in item.comboItems" :key="'cb' + index + indexCb" class="px-2 pt-2 mb-2">
                          <p class="p-0 m-0 d-flex"><v-icon class="icon-list icon-sku">mdi-circle-small</v-icon><span>{{ itemCb.tempItem.name }}</span></p>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon class="ml-3 cursor-pointer" color="#329D20" @click="editSku(item, index)" v-bind="attrs" v-on="on">
                          mdi-pencil
                        </v-icon>
                      </template>
                      <span>Chỉnh sửa</span>
                    </v-tooltip>
                  </li>
                  <li>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-if="!item.id" class="ml-3 cursor-pointer" color="#959595" @click="deleteSku(item, index)" v-bind="attrs" v-on="on">
                          mdi-delete
                        </v-icon>
                      </template>
                      <span>Xóa</span>
                    </v-tooltip>
                  </li>
                  <li>
                    <v-tooltip bottom v-if="item.id">
                      <template v-slot:activator="{ on }">
                        <a :href="`${detailSkuLink(item, index)}`" rel="noopener noreferrer" @click.prevent>
                          <v-icon v-on="on" class="ml-3 cursor-pointer" color="#959595" @click="detailSku(item, index)">
                              mdi-sale
                          </v-icon>
                        </a>
                      </template>
                      <span>Chính sách</span>
                    </v-tooltip>
                  </li>
                </ul>
                <!-- <v-icon class="ml-3 cursor-pointer" color="#4048FF">
                  mdi-plus-circle-outline
                </v-icon> -->
              </td>
            </tr>
          </template>
          <tr v-if="skuItems.length < 4" class="tr-no-data"><td colspan="6"></td></tr>
        </tbody>
      </v-simple-table>
    </v-col>

    <!------------ComboForm------------>
    <v-dialog
      v-if="isShowForm"
      v-model="isShowForm"
      persistent
      :max-width="isShowFindSku ? 1650 : 1400"
    >
     <ComboForm
     :isCreate="isCreate"
      :sku="skuSelected"
      :productAttributes="productAttributes"
      :categories="categories"
      @close="closeForm"
      @showFindSku="isShowFindSku = true"
      @saveSku="saveSku"
      />
    </v-dialog>
  </v-row>
</template>

<script>
import SkuCombo from '../../models/SkuCombo';
import {
  productTypeCombo,
} from '../../../../helpers/constants';

import RepositoryFactory from '@/repositories/RepositoryFactory';
const ProductRepository = RepositoryFactory.get('product');

import ComboForm from './ComboForm.vue';

export default {
  name: 'duo-sku-list',
  components: {
    ComboForm,
  },
  props:{
    skuItems: {
      type: Array,
      default: () => [],
    },
    productAttributes: {
      type: Object,
      default: () => {},
    },
    categories: {
      type: Array,
      default: () => [],
    },
    productId: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      isShowFindSku: false,
      isShowForm: false,
      tab: 0,
      txtSkuName: null,
      skuStatusObj: {},
      subjectsObj: {},
      skuSelected: {},
      productTypeCombo,
      isCreate: true,
      indexSelected: null,
    };
  },
  computed: {
  },
  async created() {
    this.productAttributes.skuStatus.forEach((item) => {
      this.skuStatusObj[item.id || item.code] = item.name;
    });
    this.productAttributes.subjects.forEach((item) => {
      this.subjectsObj[item.id] = item.name;
    });
  },
  beforeDestroy() {
  },
  methods: {
    searchSkuOffline: _.debounce(function(item, index, type = null) {
      this.$emit('searchSkuOffline', this.txtSkuName.trim());
    }, 500),
    async saveSku(data) {
      this.skuSelected = {};
      if (!data.id) {
        // Create product combo
        if (!this.productId) {
          delete data.code;
          delete data.id;

          const comboItems = data.comboItems.map((item) => {
            return {
              ...item,
              tempItem: item,
            };
          });

          data.comboItems = comboItems;
          if (!this.indexSelected && this.indexSelected != 0) {
            this.skuItems.push(data);
          }
          if (this.indexSelected || this.indexSelected === 0) {
            this.skuItems[this.indexSelected] = data;
            this.indexSelected = null;
          }
        }

        // Edit product
        if (this.productId) {
          const comboItems = data.comboItems.map((item) => {
            return {
              itemId: item.itemId,
              itemType: item.itemType,
              itemQuantity: item.itemQuantity,
            };
          });
          const body = {
            productId: this.productId,
            productType: this.productTypeCombo,
            skuItem: {
              name: data.name.trim(),
              orgPrice: data.orgPrice,
              cardDisplayName: data.cardDisplayName.trim(),
              comboPrice: parseInt(data.comboPrice),
              status: data.status,
              transactionStatus: data.transactionStatus,
              comboItems
            },
          };
          const res = await ProductRepository.createSkucombo(data.id, body)
          if (res.data) {
            this.$emit('reloadSkuList');
            this.$swal({
              type: "success",
              icon: "success",
              title: "Tạo mới thành công!",
              toast: true,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        }
      }

      // Edit product
      if (data.id) {
        const comboItems = data.comboItems.map((item) => {
          return {
            itemId: item.itemId,
            itemType: item.itemType,
            itemQuantity: item.itemQuantity,
          };
        })
        const body = {
          productId: this.productId,
          productType: this.productTypeCombo,
          skuItem: {
            name: data.name.trim(),
            cardDisplayName: data.cardDisplayName.trim(),
            orgPrice: data.orgPrice,
            comboPrice: parseInt(data.comboPrice),
            status: data.status,
            transactionStatus: data.transactionStatus,
            comboItems
          },
        };
        const res = await ProductRepository.updateSkucombo(data.id, body)
        if (res.data && res.data[0] == 1) {
          this.$emit('reloadSkuList');
          this.$swal({
            type: "success",
            icon: "success",
            title: "Cập nhật thành công!",
            toast: true,
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Có lỗi xảy ra',
          });
        }
      }
    },
    deleteSku(item, index) {
      if (!item.id) {
        this.skuItems.splice(index, 1);
      }
    },
    getSubjectTitle(comboList) {
      const subjects = []
      comboList.forEach((item) => {
        if (!subjects.includes(this.subjectsObj[item.tempItem.subjectId])) {
          subjects.push(this.subjectsObj[item.tempItem.subjectId]);
        }
      });

      return subjects.join(', ')
    },
    editSku(item, index) {
      this.skuSelected = item;
      this.indexSelected = index;
      this.isShowForm = true;
      this.isCreate = false;
    },
    closeForm() {
      this.isShowForm = false;
      this.isShowFindSku = false;
      this.skuSelected = {};
      this.indexSelected = null;
    },
    createSku() {
      this.isShowForm = true;
      this.isCreate = true;
    },
    detailSku(item) {
      this.$router.push({
        path: `/products/${this.productId}/sku-combo/${item.id}`,
        query: {
          sku_type: 'combo',
        },
      });
    },
    detailSkuLink(item) {
			return `/products/${this.productId}/sku-combo/${item.id}?sku_type=combo`;
		},
  },
  watch: {
  }
};
</script>
<style scoped lang="scss">
  .btn-save {
    background: #8465FF !important;
    color: #fff;
  }
  .btn-cancel  {
    background: #787878 !important;
    color: #fff;
  }

  .btn-info {
    background: #6587FF !important;
    color: #fff;
  }

  .icon-search {
    left: 40px;
    position: relative;
  }
  .table-custom {
    th {
      background: #E7E8FF;
      border-left: 1px solid #fff;
    }
  }
  .form-advance {
    border-left: 1px solid #ccc;
  }
  .table-select-sku th {
    min-width: 40px;
  }
  .btn-success {
    background: #048F0A !important;
    color: #fff;
  }
  .col-code {
    width: 20%;
  }
  .col-name{
    width: 40%;
  }
  .col-price{
    width: 30%;
  }
  .col-action{
    width: 10%;
  }
  .data-list:hover .list-combo {
    display: block;
    width: 240px;
    left: -150px
  }

  .data-list {
    position: relative;
  }
  .list-combo {
    display: none;
    position: absolute;
    border: 1px solid #ccc;
    background: #fff;
    z-index: 10000;
  }
  .list-action {
    list-style: none;
    display: flex;
  }
</style>

<style lang="scss">
  .text-field-small {
    .v-input__slot {
      // height: 35px;
      min-height: 20px !important;
    }
  }
  .text-field fieldset {
    background: #fff !important;
  }
  .text-search {
    .v-input__slot {
      min-height: 20px !important;
      padding-left: 35px !important;
    }
  }
 
  .text-field-custom {
    fieldset {
      background: #fff !important;
    }
  }
  .text-bold {
    font-weight: bold;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .text-red {
    color: red;
  }
  .table-sku .tr-no-data{
    height: 240px !important;
  }
  .icon-sku {
    display: unset !important;
    box-align: unset !important;
  }
</style>
